import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import Router from "next/router";
import Head from "next/head";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { CancelRounded } from "@material-ui/icons";

import Layout from "../../../components/Layout";
import FormInput from "../../../components/formInput/formInput";
import axiosInstance from "../../../config/axios";
import { loader } from "../../../store/actions/loader";
import { storeAuth, logout } from "../../../store/actions/auth";
import InlineLoading from "../../../components/UI/inlineLoader";
import { auth } from "../../../components/hoc/auth";

const EditAccount = () => {
  const [windowSize, setWindowSize] = useState({
    height: null,
    width: null,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ height: window.innerHeight, width: window.innerWidth });
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // console.log(`window dimensions: ${windowSize.height} ${windowSize.width}`);

 

  // All store
  const loadingState = useSelector((state) => state.loader.loading);
  let user = useSelector((state) => state.auth) || {};

  const { register, handleSubmit, errors, reset } = useForm();

  const dispatch = useDispatch();

  const editAccountHandler = async (data) => {
    console.log("data fecthcing", data)
    const userToken = Cookies.get("token");
    dispatch(loader());
    try {
      if (data) {
        const { data: response } = await axiosInstance.post("user", data, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        dispatch(storeAuth(response.data));
        // setValue((value) => ++value);
        dispatch(loader());
        NotificationManager.success(response.message, "", 3000);
        Router.push("/profile");

       
      }
    } catch (error) {
      dispatch(loader());
      // console.log(error);
      NotificationManager.error(error.response.data.message, "", 3000);
    }
    reset({});
  };

  const logoutHandler = () => {
    Router.push("/signup");
    dispatch(logout());
    dispatch(setRecentOrders([]));
  };

 
  useEffect(() =>{
    console.log("checking user", user)
  }, [])

  return (
    <>
      <Layout showSecFooter>
        <Head>
          <title>Edit Account | Kilimanjaro</title>

          <meta
            name="description"
            content="Kilimanjaro restaurant is a Nigerian restaurant brand owned by Sundry Foods. If you're looking for delicious Nigerian cuisine in a welcoming atmosphere, Kilimanjaro should be at the top of your list. This page tells you more about the restaurant and the delicious African cuisine it offers"
          />
        </Head>
        <h1 className="visually-hidden">
          Kilimanjaro edit account page
        </h1>

        <section className="signup">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mx-auto">
                <div className="border-line">
                  <h3 className="text-center">Account information</h3>
                  <p className="mb-3">
                    {" "}
                    Change or update your account information here.
                  </p>
                  <form
                    onSubmit={handleSubmit(editAccountHandler)}
                    className="signup-form"
                  >
                    <FormInput
                      type="text"
                      name="first_name"
                      placeholder="First Name*"
                      label="First Name"
                      register={register({
                        required: "First name is required",
                      })}
                      error={errors.first_name && errors.first_name.message}
                      defaultValue={user?.user?.first_name}
                    />
                    <FormInput
                      type="text"
                      name="last_name"
                      placeholder="Last Name*"
                      label="Last Name"
                      register={register({ required: "Last name is required" })}
                      error={errors.last_name && errors.last_name.message}
                      defaultValue={user?.user?.last_name}
                    />
                    <FormInput
                      type="email"
                      name="email"
                      placeholder="Example@email.com*"
                      label="Email Address"
                      register={register({
                        required: "Please input a valid email address",
                        // pattern: /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
                      })}
                      defaultValue={user?.user?.email}
                      error={errors.email && errors.email.message}
                      disabled
                    />
                    <FormInput
                      type="number"
                      name="phone"
                      placeholder="+234 80 1234 5678*"
                      label="Mobile Number"
                      register={register({
                        required: "Phone number is required",
                      })}
                      defaultValue={user?.user?.phone}
                      error={errors.phone && errors.phone.message}
                      
                    />
                      {loadingState ? (
                    <div className="text-center">
                      <InlineLoading />
                    </div>
                  ) : (
                    <div className="d-flex">
                      <button className="btn w-50 btn-order mt-3 mr-4" type="submit">
                        <span className="text">Save</span>
                      </button>
                      

                      
                    </div>
                  )}
                  </form>
                
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default auth(EditAccount);
